import { render, staticRenderFns } from "./stageDetail.vue?vue&type=template&id=8354e714&scoped=true&"
import script from "./stageDetail.vue?vue&type=script&lang=js&"
export * from "./stageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8354e714",
  null
  
)

export default component.exports